import { render, staticRenderFns } from "./Onboarding_agregar.vue?vue&type=template&id=2492724f"
import script from "./Onboarding_agregar.vue?vue&type=script&lang=js"
export * from "./Onboarding_agregar.vue?vue&type=script&lang=js"
import style0 from "./Onboarding_agregar.vue?vue&type=style&index=0&id=2492724f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports